import ReadingEnvironment from './ReadingEnvironment';
export default ReadingEnvironment;
